import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useState } from 'react';

const BottomDockedHeightContext = createContext(0);
const BottomDockedHeightSetterContext = createContext<
  (height: number) => void
>(() => {});

export const BottomDockedHeightProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [height, setHeight] = useState(0);
  return (
    <BottomDockedHeightContext.Provider value={height}>
      <BottomDockedHeightSetterContext.Provider value={setHeight}>
        {children}
      </BottomDockedHeightSetterContext.Provider>
    </BottomDockedHeightContext.Provider>
  );
};

export const useBottomDockedHeight = () =>
  useContext(BottomDockedHeightContext);

export const useRegisterBottomDockedHeight = (height: number) => {
  const setHeight = useContext(BottomDockedHeightSetterContext);
  useEffect(() => {
    setHeight(height);
    return () => setHeight(0);
  }, [height, setHeight]);
};
